<app-preloader></app-preloader>
<div class="app-wrapper" *ngIf="ready">
  <app-header *ngIf="showHeader"></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
